import React, { forwardRef } from 'react';
import cm from 'classnames';

import styles from '../_input.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  alert?: boolean;
}

const InputBase = forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const { className, alert, value, ...rest } = props;
  const finalClassName = cm(styles.InputBase, className, {
    [styles['InputBase--alert']]: alert,
  });

  return <input value={value} {...rest} ref={ref} className={finalClassName} />;
});
InputBase.displayName = 'InputBase';

export { InputBase };
